import { ReactNode } from 'react';
import { css } from '@emotion/react';
import { useThemeValues } from '../../../hooks/use-theme-values';
import { NakedUl } from '../../../naked/naked-ul.component';

export const ListFieldUl: React.FC<React.PropsWithChildren<{ children: ReactNode }>> = ({ children }) => {
  const theme = useThemeValues();
  return (
    <NakedUl
      css={css`
        margin: ${theme.spacing(2, 0, 0)};
      `}
    >
      {children}
    </NakedUl>
  );
};
